import React from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const MBConfirmationPopup = ({
  open,
  handleClose,
  handleConfirm,
  title,
  message,
  confirmText,
  cancelText,
  loadingBtn,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={handleClose} variant="text" color="info">
          {cancelText}
        </MDButton>
        <MDButton
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={loadingBtn}
          startIcon={loadingBtn ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {confirmText}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

// Define PropTypes
MBConfirmationPopup.propTypes = {
  open: PropTypes.bool.isRequired, // Whether the dialog is open
  handleClose: PropTypes.func.isRequired, // Function to close the dialog
  handleConfirm: PropTypes.func.isRequired, // Function to confirm deletion
  title: PropTypes.string, // Dialog title
  message: PropTypes.string, // Confirmation message
  confirmText: PropTypes.string, // Confirm button text
  cancelText: PropTypes.string, // Cancel button text
  loadingBtn: PropTypes.bool,
};

// Default props
MBConfirmationPopup.defaultProps = {
  title: "Confirm Deletion",
  message: "Are you sure you want to delete this item? This action cannot be undone.",
  confirmText: "Delete",
  cancelText: "Cancel",
  loadingBtn: false,
};

export default MBConfirmationPopup;
